<template>
  <VueOnGeoAutocomplete :label="label"
                        :url="realUrl"
                        text="title"
                        value="title"
                        title="title"
                        subTitle="subTitle"
                        :wrapper="wrapItem"
                        :clearable="clearable"
                        :solo-inverted="soloInverted"
                        :solo="solo"
                        :dense="dense"
                        :flat="flat"
                        :hide-details="hideDetails"
                        :open-on-clear="openOnClear"
                        :color="color"
                        :hint="hint"
                        :persistent-hint="persistentHint"
                        @selected="selected"></VueOnGeoAutocomplete>
</template>

<script>
import VueOnGeoAutocomplete from "./vue-ongeo-autocomplete.vue";

export default {
  name: "vue-ongeo-plot-search-autocomplete",
  components: {
    VueOnGeoAutocomplete
  },
  props: {
    url: { type: String },
    label: { type: String, default: "Kraków 209/1 0030" },
    additionalData: { type: Array, default: () => { return ["address", "details"] } },

    color: { type: String },
    clearable: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: true },
    solo: { type: Boolean, default: false },
    soloInverted: { type: Boolean, default: true },
    openOnClear: { type: Boolean, default: true },
    hint: { type: String, default: null },
    persistentHint: { type: Boolean, default: false }

  },
  computed: {
    realUrl () {
      let additionalDataParam = this.additionalData.join(",");
      return this.url
        ? this.url
        : process.env.VUE_APP_SEARCH_PLOT_SERVICE_URL +
        `?api_key=${
        process.env.VUE_APP_API_KEY
        }&additionalData=${additionalDataParam}&query=`;
    }
  },
  methods: {
    wrapItem (entry) {
      let { address, details, globalId } = entry;
      let subTitle = [];
      if (address.province) subTitle.push(`pow. ${address.province}`);
      if (address.state) subTitle.push(`, woj. ${address.state}`);
      let title = "";
      if (details.number) title += `dz. ${details.number}, `;
      if (address.cadastralUnit) title += `${address.cadastralUnit}, `;
      if (address.precinct)
        title += `obr. ${address.precinct} (${address.precinctNumber})`;

      return {
        title: title,
        subTitle: subTitle.join(" "),
        address: entry,
        globalId
      };
    },
    selected (item) {
      this.$emit("selected", item);
    }
  }
};
</script>
